import React, { Suspense, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useLocation } from "react-router-dom";

const LazyRender = ({ children, height = "370px", id }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (inView) setIsVisible(true);
  }, [inView]);

  useEffect(() => {
    if (id && location.hash === `#${id}`) {
      setIsVisible(true);
    }
  }, [location.hash, id]);

  return (
    <section ref={ref} id={id} style={{ minHeight: height }}>
      {isVisible && (
        <Suspense fallback={<div style={{ height }}>Loading...</div>}>
          {children}
        </Suspense>
      )}
    </section>
  );
};

export default LazyRender;